//export const SERVER_URL = "http://localhost:9999/MoradaServer";
export const SERVER_URL = "https://memorial-backend.irmaosvila.com.br";